import React, { useState } from 'react';
import Button from '../../../components/ui/Button';

const ActionButtons = ({ onReschedule, onContactSupport, onCancelService }) => {
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  const handleCancelClick = () => {
    setShowCancelConfirm(true);
  };

  const handleConfirmCancel = () => {
    onCancelService();
    setShowCancelConfirm(false);
  };

  const handleCancelDismiss = () => {
    setShowCancelConfirm(false);
  };

  return (
    <>
      <div className="bg-card rounded-lg p-6 shadow-sm border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Actions disponibles</h3>
        
        <div className="space-y-3">
          <Button
            variant="outline"
            fullWidth
            iconName="Calendar"
            iconPosition="left"
            onClick={onReschedule}
          >
            Reprogrammer l'intervention
          </Button>

          <Button
            variant="outline"
            fullWidth
            iconName="MessageCircle"
            iconPosition="left"
            onClick={onContactSupport}
          >
            Contacter le support
          </Button>

          <Button
            variant="ghost"
            fullWidth
            iconName="XCircle"
            iconPosition="left"
            onClick={handleCancelClick}
            className="text-error hover:bg-error/10"
          >
            Annuler l'intervention
          </Button>
        </div>

        <div className="mt-4 p-3 bg-muted rounded-lg">
          <p className="text-xs text-muted-foreground">
            <span className="font-medium text-foreground">Besoin d'aide ?</span> Notre équipe support est disponible 24/7 pour répondre à vos questions.
          </p>
        </div>
      </div>

      {showCancelConfirm && (
        <div className="fixed inset-0 z-[1100] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm animate-fade-in">
          <div className="bg-card rounded-lg shadow-lg border border-border max-w-md w-full p-6 animate-scale-in">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center flex-shrink-0">
                <Button
                  variant="ghost"
                  size="icon"
                  iconName="AlertTriangle"
                  className="text-error"
                />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  Confirmer l'annulation
                </h3>
                <p className="text-sm text-muted-foreground">
                  Êtes-vous sûr de vouloir annuler cette intervention ? Cette action est irréversible et des frais d'annulation peuvent s'appliquer selon nos conditions.
                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <Button
                variant="outline"
                fullWidth
                onClick={handleCancelDismiss}
              >
                Retour
              </Button>
              <Button
                variant="destructive"
                fullWidth
                onClick={handleConfirmCancel}
              >
                Confirmer l'annulation
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ActionButtons;